import type { SpaceGits } from "@indietabletop/types";
import { differenceBy, unionBy } from "es-toolkit";
import { type Ref, refToUniqueKey } from "./refs.ts";

export function getUpdatedWeaponRefs<
  T extends SpaceGits.WeaponRef | SpaceGits.VehicleWeaponRef,
>(currentRefs: T[], nextRefs: T[]) {
  const allRefs = unionBy(nextRefs, currentRefs, (ref) => ref.id);

  const currentCountsById = new Map(
    currentRefs.map((ref) => [ref.id, ref.count]),
  );

  const nextCountsById = new Map(nextRefs.map((ref) => [ref.id, ref.count]));

  const updated = allRefs
    .map((ref) => {
      const currentCount = currentCountsById.get(ref.id) ?? 0;
      const nextCount = nextCountsById.get(ref.id) ?? 0;
      return { ...ref, count: nextCount - currentCount };
    })
    .filter((diff) => diff.count !== 0);

  return updated;
}

export function getAddedRefs<T extends Ref>(currentRefs: T[], nextRefs: T[]) {
  return differenceBy(nextRefs, currentRefs, refToUniqueKey);
}
